<template>
  <div class="refund-approval">
    <el-dialog title="退款申请" width="40%" :show-close="false" center :visible.sync="visible">
      <p>
        退款金额：<span class="c-red"
          >￥{{ refundDetail.refundAmount | formatMoneyCent | formatPermil }}</span
        >
      </p>
      <p>退款原因：{{ refundDetail.refundReason }}</p>
      <p>退款方式：{{ getRefundWay }}</p>
      <el-form :model="form" label-position="left" style="margin-top: 10px;">
        <el-form-item v-if="isApproval" label="退款凭证" :label-width="formLabelWidth">
          <el-input type="textarea" rows="3" v-model="form.bankOrderId"> </el-input>
        </el-form-item>
        <el-form-item v-else label="驳回原因" :label-width="formLabelWidth">
          <el-input type="textarea" rows="3" v-model="form.operateDescription"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirmRefundApproval">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { refundWay, refuseActionType } from '../code'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isApproval: {
      type: Boolean,
      default: true
    },
    refundDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {
        bankOrderId: '',
        operateDescription: ''
      },
      formLabelWidth: '120px'
    }
  },
  computed: {
    getRefundWay() {
      const { GOODS, MONEY } = refuseActionType
      const { refundType } = this.refundDetail
      if ([GOODS, MONEY].includes(refundType)) {
        return '线下退款'
      }
      return '线上原路退款'
    }
  },
  methods: {
    confirmRefundApproval() {
      let params = {}
      const { bankOrderId, operateDescription } = this.form
      if (this.isApproval) {
        params.bankOrderId = bankOrderId
      } else {
        params.operateDescription = operateDescription
      }
      this.$emit('apply', params, this.refundDetail)
      this.clearDialog()
    },

    closeDialog() {
      this.$emit('close')
      this.clearDialog()
    },

    clearDialog() {
      for (let key in this.form) {
        if (this.form.hasOwnProperty(key)) {
          this.form[key] = ''
        }
      }
    }
  }
}
</script>

<style></style>
